import { gql, useMutation } from "@apollo/client";

import { CreateAssetInput } from "../../generated/gql/graphql";

const CREATE_ASSET = gql`
  mutation Mutation($input: CreateAssetInput!) {
    createAsset(input: $input) {
      id
    }
  }
`;

type CreateAssetApi = {
  createAsset(input: CreateAssetInput): Promise<unknown>;
  isCreateAssetLoading: boolean;
};

export default function useCreateAsset(): CreateAssetApi {
  const [createNewAsset, { loading }] =
    useMutation<CreateAssetInput>(CREATE_ASSET);

  async function createAsset(input: CreateAssetInput): Promise<unknown> {
    return await createNewAsset({
      context: {
        headers: {
          "apollo-require-preflight": true,
        },
      },
      variables: {
        input,
      },
    });
  }

  return {
    createAsset,
    isCreateAssetLoading: loading,
  };
}
